import React, { useState, useEffect } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import Sidebar from './Sidebar';
import Header from './Header';
import { useAuth } from '../../context/AuthContext';

const MainLayout = () => {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const location = useLocation();
  const { user } = useAuth();

  useEffect(() => {
    const handleResize = () => {
      const mobile = window.innerWidth <= 768;
      setIsMobile(mobile);
      
      // Sur desktop, sidebar toujours ouverte
      if (!mobile) {
        setSidebarOpen(true);
      } else {
        setSidebarOpen(false);
      }
    };

    handleResize();
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  // Fermer la sidebar sur mobile quand on change de page
  useEffect(() => {
    if (isMobile) {
      setSidebarOpen(false);
    }
  }, [location, isMobile]);

  const toggleSidebar = () => {
    setSidebarOpen(!sidebarOpen);
    // Empêcher le scroll du body quand la sidebar est ouverte sur mobile
    if (!sidebarOpen && isMobile) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }
  };

  const closeSidebar = () => {
    setSidebarOpen(false);
    document.body.style.overflow = 'unset';
  };

  return (
    <div className="app-container">
      <Sidebar isOpen={sidebarOpen} onClose={closeSidebar} />
      
      <main className={`main-content ${!sidebarOpen ? 'expanded' : ''}`}>
        <Header 
          toggleSidebar={toggleSidebar} 
          isMobile={isMobile} 
          user={user}
          sidebarOpen={sidebarOpen}
        />
        
        <div className="content-wrapper">
          <Outlet />
        </div>
      </main>

      {/* Overlay pour mobile */}
      {isMobile && (
        <div 
          className={`sidebar-overlay ${sidebarOpen ? 'active' : ''}`} 
          onClick={closeSidebar}
        />
      )}
    </div>
  );
};

export default MainLayout;